// extracted by mini-css-extract-plugin
export default {"text":"Svwj1","averageNote":"kpCus"};